import { useTranslation } from "react-i18next";
import IRequestBodyProps from "./IRequestBodyProps";
import { useMsal } from "@azure/msal-react";
import { Badge, Card, Col, Container, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import BackButton from "../../../components/backButton/BackButton";
import { Icon } from "../../../components/icon/Icon";
import ReadOnlyBody from "./ReadOnlyBody";
import EditorBody from "./EditorBody";

export default function RequestBody(props: IRequestBodyProps) {
    const { t } = useTranslation();
    const { accounts } = useMsal();
    const { request } = props;

    const username = accounts[0].username;

    return (
        <Card.Body>
            <Card.Title className="d-flex align-items-center mb-3">
                <BackButton path="/sars" />
                <span>{request.reference}</span>
            </Card.Title>
            <Card.Text as="div">
                <Container fluid>
                    <Row>
                        <Col>
                            <h1 className="h2">{request.custodian}</h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="d-flex gap-2 mb-3 w-100 overflow-x-auto">
                                <OverlayTrigger placement="top" overlay={<Tooltip>{t("dsar.badges.status")}</Tooltip>}>
                                    <Badge bg="primary" className="fw-normal">
                                        <Icon iconName="Clock" endMargin={1} />
                                        <span className="mb-0">{request.status}</span>
                                    </Badge>
                                </OverlayTrigger>

                                {
                                    !!request.requestor?.name &&
                                    username !== request.requestor.email &&
                                    <OverlayTrigger placement="top" overlay={<Tooltip>{t("general.createdBy")}</Tooltip>}>
                                        <Badge bg="secondary" className="fw-normal">
                                            <Icon iconName="PersonPlusFill" endMargin={1} />
                                            <span className="mb-0">{request.requestor.name}</span>
                                        </Badge>
                                    </OverlayTrigger>
                                }
                            </div>
                        </Col>
                    </Row>
                    {
                        request.status === "More Details Required" && request.requestor?.email === username
                            ? <EditorBody request={request} />
                            : <ReadOnlyBody request={request} />
                    }
                </Container>
            </Card.Text>
        </Card.Body>
    );
};